import type { McpServerConfig } from "types/Mcp";

export const API = {
  cortevaChain: {
    url: "https://vylor-chat-api.dataplatform.research.vylor.com",
  },
  fileApi: {
    url: "https://vc-file-api.dataplatform.research.vylor.com",
  },
  dbApi: {
    url: "https://vylor-chat-api.dataplatform.research.vylor.com/chat",
  },
  metricsApi: {
    url: "https://corteva-chat-metrics.kube2.research.vylor.com",
    scope: "api://ef35ff68-77a2-4b17-834d-1c9f185aea87/access_as_user",
  },
};

// Azure SSO auth configuration. Used by MSAL.
export const azureClientId = "27f9ef33-08c7-42af-9653-be874c5de40b";
export const azureAuthority =
  "https://login.microsoftonline.com/db505480-8ec6-495c-b579-32c58ed84a01";
export const azureRedirectUri = "https://chat.research.vylor.com/";

export const MCP_SERVERS = {
  wallipedia: {
    url: "https://wallipedia.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://a9a00db4-d6ae-44f2-aec0-8a0320bf3eca/user",
  },
  rookery: {
    url: "https://rookery.dataplatform.research.vylor.com/mcp-pd",
    transport: "streamable_http",
    oauth_scopes: "api://5950d605-3c42-4683-92fc-acd7b965577f/user",
  },
  media_mcp: {
    url: "https://media-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://aa1bc25c-34df-4331-aaf3-baec64eecc06/user",
  },
  midas_mcp: {
    url: "https://midas-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://ab32e1e4-e207-41bb-bd89-28a475a2578d/user",
  },
  trino_query_assistant: {
    url: "https://trino-query-assistant.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://3b63714c-2e5d-4370-8e1e-dff756cbd70b/user",
  },
  btsat_mcp: {
    url: "https://btsat-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://ce3fd889-bb58-4205-93b3-5ae11d53030f/user",
  },
  evman_mcp: {
    url: "https://evman-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://e972d33c-4fbb-46e2-bdfc-1053b70b3ef0/user",
  },
  agnlp_mcp: {
    url: "https://agnlp-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://26bece14-8751-467a-bc5e-98b662b3b196/user",
  },
  gaia_mcp: {
    url: "https://gaia-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://b5b572a9-b2ae-4084-af9b-f8ad4915b398/user",
  },
  skyfall_mcp: {
    url: "https://skyfall-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://e9d6f0eb-4578-4fb3-9b8d-e1f0d477854e/user",
  },
  sfa_mcp: {
    url: "https://sfa-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://de8157c4-cc54-41ae-abeb-4e88d3fc761f/user",
  },
  synteny_mcp: {
    url: "https://synteny-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://1ab9b875-c1fd-4d25-af31-6b9da65f86ac/user",
  },
  breeding_tools_mcp: {
    url: "https://breeding-tools-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://f7536562-1881-407a-ae88-4bda6effc37f/user",
  },
  galileo_mcp: {
    url: "https://galileo-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes:
      "api://b3bb9b9a-dda7-4c4e-bbdf-10e083849f0d/generalAccess.scope",
  },
  executeCode: {
    url: "https://code-execution-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://3b75954e-b296-4260-a5f9-db61efff399a/user",
  },
  // Subagent MCP is hosted in-process by vylor-chat-api, so this URL is
  // resolved by the chat-api server (not the browser). Same value in every
  // env because every chat-api deployment serves /subagent/mcp on its own
  // loopback.
  subagent: {
    url: "http://0.0.0.0:8000/subagent/mcp",
    transport: "streamable_http",
    oauth_scopes:
      "api://27f9ef33-08c7-42af-9653-be874c5de40b/user_impersonation",
  },
  cc_file_api: {
    url: "https://vc-file-api.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://90475828-93c0-4d45-ac22-32a6a3c9f5fd/access_as_user",
  },
  jupyterhub_mcp_shim: {
    url: "https://jupyterhub-mcp-shim.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes: "api://67a85bf3-82b2-49ae-ac47-9cf19f34359c/user",
  },
  datahub_mcp: {
    url: "https://datahub-mcp.dataplatform.research.vylor.com/mcp",
    transport: "streamable_http",
    oauth_scopes:
      "api://4885675c-49c6-40e2-b382-c217f96f6076/generalAccess.scope",
  },
} as const satisfies Record<string, McpServerConfig>;

// When true, the context gauge shows tokens relative to the compaction trigger threshold.
// When false, it shows tokens relative to the model's full context budget.
export const ENABLE_CONTEXT_GAUGE_FOR_COMPACTION = true;
